<template>
  <div class="lp-gym01">
    <lp-header :logo-src="logoPath" />
    <component :is="currentPage" v-bind="pageProps" />
    <lp-footer />
  </div>
</template>

<script>
import LpHeader from './LpHeader'
import LpFooter from './LpFooter'
import LpTopPage from './LpTopPage'
import LpAddingQuestions from './LpAddingQuestions'
import LpThanks from './LpThanks'

const PAGE_MAP = {
  top: 'LpTopPage',
  adding_questions: 'LpAddingQuestions',
  thanks: 'LpThanks'
}

export default {
  name: 'LpApp',
  components: { LpHeader, LpFooter, LpTopPage, LpAddingQuestions, LpThanks },
  props: {
    page: { type: String, required: true },
    imagePaths: { type: Object, default: () => ({}) },
    inquiryId: { type: [String, Number], default: null }
  },
  computed: {
    currentPage () {
      return PAGE_MAP[this.page] || 'LpTopPage'
    },
    logoPath () {
      return this.imagePaths.logo || ''
    },
    pageProps () {
      if (this.page === 'adding_questions') {
        return { inquiryId: this.inquiryId, imagePaths: this.imagePaths }
      }
      return { imagePaths: this.imagePaths }
    }
  }
}
</script>
